import { takeLatest, put, call } from 'redux-saga/effects';
import { SCORE_DEFINATION } from '../../../config'
import {
    GET_CREDIT_LIMIT_MODEL_LIST,
    getCreditLimitModelListSuccess

} from './action';
import { HTTP_HEADERS } from '../../../constants';
import request from "../../../components/Utils/httpHelper";


export function* getCreditLimitListSaga(action) {
    let requestURL = `${SCORE_DEFINATION}/creditlimit/model/list`;
    console.log(requestURL)
    try {
        const result = yield call(request, requestURL, { data: action.data, method: 'GET', headers: HTTP_HEADERS });
        yield put(getCreditLimitModelListSuccess(result.data));
    } catch (err) {
        yield put(getCreditLimitModelListSuccess(err))
    }
}
export function* viewAllCreditLimitModelSaga() {
    yield takeLatest(GET_CREDIT_LIMIT_MODEL_LIST, getCreditLimitListSaga);
}
